// Chemins relatifs à la base `/api/v1` du client HTTP (comme `kybMandateEndpoints`).
const base = (caseId: string) => `/compliance/kyb/legal-entity-cases/${caseId}`;

const kybCorporateAccessEndpoints = {
  list: (caseId: string) => `${base(caseId)}/corporate-access`,
  create: (caseId: string, mandateId: string) =>
    `${base(caseId)}/mandates/${mandateId}/corporate-access`,
  reactivationMfaChallenge: (caseId: string, mandateId: string) =>
    `${base(caseId)}/mandates/${mandateId}/corporate-access/reactivation/mfa-challenge`,
  reactivation: (caseId: string, mandateId: string) =>
    `${base(caseId)}/mandates/${mandateId}/corporate-access/reactivation`,
  profile: (caseId: string, accessId: string) =>
    `${base(caseId)}/corporate-access/${accessId}/profile`,
  profileMfaChallenge: (caseId: string, accessId: string) =>
    `${base(caseId)}/corporate-access/${accessId}/profile/mfa-challenge`,
};

export default kybCorporateAccessEndpoints;
